import * as React from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { SelectMultipleHierarchy } from 'app/area/shared/translated-components';

export interface AddFiltersSelectProps {
  translation: any;
  valueItems: ComplexValue<number>[];
  options: ComplexValue<number>[];
  onChange: (valueItem: ComplexValue<number>[]) => void;
  onLoadAdvancedSearchFields: (query?: string) => void;
  locale: string;
}

export interface AddFiltersSelectState {
  loadOptions: LoadOptions;
  isFetching: boolean;
}

export class AddFiltersSelect extends React.Component<AddFiltersSelectProps, AddFiltersSelectState> {

  public state: Readonly<AddFiltersSelectState> = {
    loadOptions: undefined,
    isFetching: false
  };

  private onLoadOptions = (loadOptions: LoadOptions) => {
    this.setState({ loadOptions, isFetching: true }, () => {
      this.props.onLoadAdvancedSearchFields(loadOptions.query);
    });
  }

  public componentDidUpdate (prevProps: AddFiltersSelectProps) {
    if (this.props.options !== prevProps.options) {
      this.setState({isFetching: false});
    }
  }

  public render() {
    const { valueItems, options, translation, locale, onChange } = this.props;

    return (<SelectMultipleHierarchy
      componentId={'1'}
      className={'multiple-hierarchy'}
      placeholder={translation && translation.filters_search_placeholder}
      valueItems={valueItems}
      loadOptions={this.state.loadOptions}
      options={options}
      onChange={onChange}
      onLoadOptions={this.onLoadOptions}
      fetching={this.state.isFetching}
      alwaysOpen={true}
      leafNodeOnly={true}
      descriptionAllLevels={true}
      locale={locale}
    />);
  }
}
